import React, { useContext, useEffect, useState } from "react";
import { requestTranslation } from "@futures-platform/i18n";
import styled from "styled-components";

export const ShowButton = styled.button`
  color: #637282 !important;
  height: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent !important;
  &:hover {
    color: white !important;
    background-color: rgb(0, 105, 152) !important;
    border: 1px solid #006998 !important;
  }
`;
const ContactSupportForm = () => {

  useEffect(() => {
    if (!!window?.Drupal?.behaviors?.hubSpotForm) {
      window?.Drupal?.behaviors?.hubSpotForm?.attach(this);
    }
  }, []);

  const renderContactButton = (hubspotFormTitle, newTitle) => {
    let resultForm = [];
    if (true) {
      if (!!window?.drupalSettings?.hubspot_form_id) {
        for (let form_id in window.drupalSettings.hubspot_form) {
          let form = window.drupalSettings.hubspot_form[form_id];

          if (form["form_title"] === hubspotFormTitle) {
            resultForm = form;

            break;
          }
        }
      }

      return (
        <>
          {!!window?.drupalSettings?.hubspot_form_id ? (
            <ShowButton
              className=" btn btn-lg btn-outline-dark dashboard-content-block justify-content-center  hubspot-modal--contact-us contact-us-link"
              style={{
                width: "fit-content",
                height: "35px",
                fontSize: "small",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
              data-toggle="modal"
              data-target={
                window?.drupalSettings?.hubspot_form_id[resultForm["form_id"]]
              }
              data-form-id={resultForm["form_id"]}
            >
              {newTitle}
            </ShowButton>
          ) : (
            <ShowButton
              className=" btn btn-lg btn-outline-dark dashboard-content-block hubspot-modal--contact-us contact-us-link"
              data-toggle="modal"
              // data-target={
              //   window?.drupalSettings?.hubspot_form_id[resultForm["form_id"]]
              // }
              style={{
                width: "fit-content",
                height: "35px",
                fontSize: "small",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
              data-form-id={resultForm["form_id"]}
            >
              {newTitle}
            </ShowButton>
          )}
        </>
      );
    }
  };

  return (
    <div className="">
    {renderContactButton("Contact Us", 'ASK FOR MORE LANGUAGES...')}
    </div>
  );
};

export default ContactSupportForm;
